import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from 'styles/partials/_selectable-list-option.css';

export default class SelectableListOption extends Component {
  render() {
    let props = Object.assign({}, this.props);
    delete props.option;
    delete props.highlight;
    delete props.index;
    delete props.selectOption;
    delete props.selectGlyph;
    delete props.descriptionField;
    delete props.onDeleteComplete;
    delete props.onMutationComplete;

    return (
      <div
        className={this.props.highlight ? styles['optionHighlight'] : styles['option']}
        {...props}
        data-test-tag={`SelectableListOption_${this.props.option.description}`}
      >
        {this.props.option.description}
      </div>
    );
  }
}

SelectableListOption.propTypes = {
  option: PropTypes.shape({
    description: PropTypes.node,
  }),
  highlight: PropTypes.bool,
};
